export class SuccessModal {
    constructor(onClose) {
        this.onClose = onClose;
        this.template = document.querySelector('#success');
    }
    render(totalPrice) {
        const content = this.template.content.cloneNode(true);
        const modal = content.querySelector('.order-success');
        // Устанавливаем сумму заказа
        const description = modal.querySelector('.order-success__description');
        if (description) {
            description.textContent = `Списано ${totalPrice} синапсов`;
        }
        // Кнопка закрытия
        const closeButton = modal.querySelector('.order-success__close');
        if (closeButton) {
            closeButton.addEventListener('click', () => {
                this.onClose();
            });
        }
        return modal;
    }
}
